<template>
  <div class="events-page">
    <!-- Croix arménienne (khatchkar) : réutilisée via <use> -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
      <symbol id="hk-cross" viewBox="-34 -40 453 752">
<mask id="hkm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="5" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="17" stroke-linejoin="round" mask="url(#hkm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="44" r="5.7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="44" r="5.7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="112" cy="88" r="5.7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="272" cy="88" r="5.7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="208" r="5.7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="302" r="5.7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="208" r="5.7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="302" r="5.7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="602" r="5.7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="602" r="5.7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="110" cy="592" r="5.7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="275" cy="592" r="5.7" fill="currentColor"/>
<circle cx="192" cy="245" r="74" fill="none" stroke="currentColor" stroke-width="5"/>
<line x1="252.0" y1="245.0" x2="265.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="255.4" x2="263.9" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="265.5" x2="260.6" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="275.0" x2="255.2" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="283.6" x2="247.9" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="291.0" x2="238.9" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="297.0" x2="228.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="301.4" x2="217.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="304.1" x2="204.7" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="305.0" x2="192.0" y2="318.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="304.1" x2="179.3" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="301.4" x2="167.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="297.0" x2="155.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="291.0" x2="145.1" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="283.6" x2="136.1" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="275.0" x2="128.8" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="265.5" x2="123.4" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="255.4" x2="120.1" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.0" y1="245.0" x2="119.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="234.6" x2="120.1" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="224.5" x2="123.4" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="215.0" x2="128.8" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="206.4" x2="136.1" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="199.0" x2="145.1" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="193.0" x2="155.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="188.6" x2="167.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="185.9" x2="179.3" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="185.0" x2="192.0" y2="172.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="185.9" x2="204.7" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="188.6" x2="217.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="193.0" x2="228.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="199.0" x2="238.9" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="206.4" x2="247.9" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="215.0" x2="255.2" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="224.5" x2="260.6" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="234.6" x2="263.9" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<circle cx="192" cy="245" r="52" fill="none" stroke="currentColor" stroke-width="6"/>
<path d="M202.0 245.0 L205.5 246.7 L208.7 249.3 L211.4 252.6 L213.4 256.7 L214.7 261.4 L215.1 266.5 L214.6 272.0 L213.0 277.6 L210.3 283.3 L206.5 288.7" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 252.1 L200.3 255.7 L200.8 259.8 L200.3 264.1 L198.9 268.4 L196.5 272.6 L193.1 276.6 L188.9 280.1 L183.7 282.9 L177.9 285.0 L171.4 286.1" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 255.0 L190.3 258.5 L187.7 261.7 L184.4 264.4 L180.3 266.4 L175.6 267.7 L170.5 268.1 L165.0 267.6 L159.4 266.0 L153.7 263.3 L148.3 259.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 252.1 L181.3 253.3 L177.2 253.8 L172.9 253.3 L168.6 251.9 L164.4 249.5 L160.4 246.1 L156.9 241.9 L154.1 236.7 L152.0 230.9 L150.9 224.4" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M182.0 245.0 L178.5 243.3 L175.3 240.7 L172.6 237.4 L170.6 233.3 L169.3 228.6 L168.9 223.5 L169.4 218.0 L171.0 212.4 L173.7 206.7 L177.5 201.3" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 237.9 L183.7 234.3 L183.2 230.2 L183.7 225.9 L185.1 221.6 L187.5 217.4 L190.9 213.4 L195.1 209.9 L200.3 207.1 L206.1 205.0 L212.6 203.9" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 235.0 L193.7 231.5 L196.3 228.3 L199.6 225.6 L203.7 223.6 L208.4 222.3 L213.5 221.9 L219.0 222.4 L224.6 224.0 L230.3 226.7 L235.7 230.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 237.9 L202.7 236.7 L206.8 236.2 L211.1 236.7 L215.4 238.1 L219.6 240.5 L223.6 243.9 L227.1 248.1 L229.9 253.3 L232.0 259.1 L233.1 265.6" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="8" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="3.5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="3.5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="3.5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="3.5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="3.5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="3.5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="3.5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
      </symbol>
      <symbol id="hk-cross-sm" viewBox="-44 -40 473 752">
<mask id="hkm-sm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="6" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="19" stroke-linejoin="round" mask="url(#hkm-sm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="44" r="7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="44" r="7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="112" cy="88" r="7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="272" cy="88" r="7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="208" r="7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="302" r="7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="208" r="7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="302" r="7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="602" r="7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="602" r="7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="110" cy="592" r="7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="275" cy="592" r="7" fill="currentColor"/>
<circle cx="192" cy="245" r="76" fill="none" stroke="currentColor" stroke-width="8"/>
<line x1="254.0" y1="245.0" x2="266.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="266.2" x2="261.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="284.9" x2="248.7" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="298.7" x2="229.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="306.1" x2="204.8" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="306.1" x2="179.2" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="298.7" x2="155.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="284.9" x2="135.3" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="266.2" x2="122.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="130.0" y1="245.0" x2="118.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="223.8" x2="122.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="205.1" x2="135.3" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="191.3" x2="155.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="183.9" x2="179.2" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="183.9" x2="204.8" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="191.3" x2="229.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="205.1" x2="248.7" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="223.8" x2="261.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<circle cx="192" cy="245" r="54" fill="none" stroke="currentColor" stroke-width="9"/>
<path d="M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="9" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="6" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <div class="bg" aria-hidden="true">
      <div class="lattice"></div>
      <svg class="bg-cross"><use href="#hk-cross" /></svg>
    </div>

    <main>

      <!-- ============ EN-TÊTE ============ -->
      <section class="page-intro">
        <div class="intro-copy">
          <span class="kicker">
            <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
            Agenda communautaire
          </span>

          <h1>
            Événements <em>arméniens</em>
          </h1>

          <p>
            Retrouvez tous les prochains événements de la communauté arménienne.
          </p>
        </div>

        <button
          type="button"
          class="create-event-btn"
          @click="$router.push('/createEvents')"
        >
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
          Créer un événement
        </button>
      </section>

      <!-- ============ FILTRES ============ -->
      <section class="filters">

        <div class="search-box">
          <label for="ev-search">Rechercher</label>

          <div class="input-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
            <input
              id="ev-search"
              v-model="search"
              type="text"
              placeholder="Rechercher un événement..."
            />
          </div>
        </div>

        <div class="filter-box">
          <label for="ev-location">Localisation</label>

          <select id="ev-location" v-model="locationFilter">
            <option value="">Toutes les localisations</option>

            <option
              v-for="location in locations"
              :key="location"
              :value="location"
            >
              {{ location }}
            </option>
          </select>
        </div>

        <div class="filter-box">
          <label for="ev-date">Date</label>

          <select id="ev-date" v-model="dateFilter">
            <option value="">Toutes les dates</option>
            <option value="today">Aujourd'hui</option>
            <option value="week">Cette semaine</option>
            <option value="month">Ce mois-ci</option>
            <option value="nextMonth">Mois prochain</option>
          </select>
        </div>

        <div class="filter-box">
          <label for="ev-sort">Trier par</label>

          <select id="ev-sort" v-model="sortBy">
            <option value="dateAsc">
              Date : bientôt
            </option>

            <option value="dateDesc">
              Date : plus tard
            </option>

            <option value="titleAsc">
              Nom : A → Z
            </option>

            <option value="titleDesc">
              Nom : Z → A
            </option>
          </select>
        </div>

      </section>

      <div class="results-info">
        <span class="count">
          <strong>{{ filteredEvents.length }}</strong>
          événement{{ filteredEvents.length > 1 ? 's' : '' }}
        </span>

        <button
          v-if="hasFilters"
          type="button"
          class="reset-btn"
          @click="resetFilters"
        >
          Réinitialiser les filtres
        </button>
      </div>

      <!-- ============ CHARGEMENT ============ -->
      <section
        v-if="loading"
        class="events-grid"
        aria-busy="true"
        aria-live="polite"
      >
        <div v-for="n in 6" :key="n" class="event-card skeleton">
          <div class="sk sk-img"></div>
          <div class="sk sk-line"></div>
          <div class="sk sk-line short"></div>
        </div>
      </section>

      <!-- ============ LISTE ============ -->
      <section
        v-else-if="filteredEvents.length > 0"
        class="events-grid"
      >

        <article
          v-for="(event, index) in filteredEvents"
          :key="event.publicId"
          class="event-card"
          :style="{ '--i': Math.min(index, 8) }"
          tabindex="0"
          role="link"
          :aria-label="`Voir les détails : ${event.title}`"
          @click="openEventDetails(event.publicId)"
          @keydown.enter="openEventDetails(event.publicId)"
        >

          <div class="event-image">

            <img
              v-if="event.image"
              :src="event.image"
              :alt="event.title"
              loading="lazy"
            />

            <div
              v-else
              class="event-image-placeholder"
              aria-hidden="true"
            >
              <svg class="placeholder-cross"><use href="#hk-cross" /></svg>
            </div>

            <div class="event-date">
              <strong>
                {{ formatDay(event.date) }}
              </strong>

              <span>
                {{ formatMonth(event.date) }}
              </span>
            </div>

          </div>

          <div class="event-content">

            <span class="event-location">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
              {{ event.location }}
            </span>

            <h2>
              {{ event.title }}
            </h2>

            <p
              v-if="event.description"
              class="event-description"
            >
              {{ event.description }}
            </p>

            <div class="event-footer">

              <span
                v-if="formatTime(event.time)"
                class="event-time"
              >
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
                {{ formatTime(event.time) }}
              </span>
              <span v-else></span>

              <span class="event-details-btn">
                Voir les détails <span class="arrow" aria-hidden="true">→</span>
              </span>

            </div>

          </div>

        </article>

      </section>

      <!-- ============ VIDE ============ -->
      <section
        v-else
        class="events-empty"
      >
        <svg class="empty-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>

        <h2>
          Aucun événement trouvé
        </h2>

        <p>
          Aucun événement ne correspond à vos critères de recherche.
        </p>

        <button
          v-if="hasFilters"
          type="button"
          class="reset-empty-btn"
          @click="resetFilters"
        >
          Réinitialiser les filtres
        </button>
      </section>

    </main>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import { useRouter } from "vue-router"
import API_URL from '@/config/api'

const router = useRouter()

const events = ref([])

const search = ref("")
const locationFilter = ref("")
const dateFilter = ref("")
const sortBy = ref("dateAsc")

const loading = ref(true)

const loadEvents = async () => {
  loading.value = true

  try {
    const response = await fetch(
      `${API_URL}/api/events/published`
    )

    if (!response.ok) {
      throw new Error("Erreur lors du chargement des événements")
    }

    const data = await response.json()

    events.value = data.map(event => ({
      ...event,
      image: event.image
        ? event.image.startsWith("http")
          ? event.image
          : `${API_URL}${event.image}`
        : null
    }))

  } catch (error) {
    console.error("Erreur événements :", error)
    events.value = []
  } finally {
    loading.value = false
  }
}

const locations = computed(() => {
  const uniqueLocations = events.value
    .map(event => event.location)
    .filter(location => location)

  return [...new Set(uniqueLocations)].sort((a, b) =>
    a.localeCompare(b, "fr")
  )
})

const filteredEvents = computed(() => {

  let result = [...events.value]

  const searchValue = search.value
    .trim()
    .toLowerCase()

  if (searchValue) {
    result = result.filter(event => {

      const title = event.title?.toLowerCase() || ""
      const description = event.description?.toLowerCase() || ""
      const location = event.location?.toLowerCase() || ""

      return (
        title.includes(searchValue) ||
        description.includes(searchValue) ||
        location.includes(searchValue)
      )
    })
  }

  if (locationFilter.value) {
    result = result.filter(
      event => event.location === locationFilter.value
    )
  }

  if (dateFilter.value) {
    const now = new Date()

    result = result.filter(event => {

      const eventDate = getEventDate(event)

      if (!eventDate) {
        return false
      }

      if (dateFilter.value === "today") {
        return (
          eventDate.getDate() === now.getDate() &&
          eventDate.getMonth() === now.getMonth() &&
          eventDate.getFullYear() === now.getFullYear()
        )
      }

      if (dateFilter.value === "week") {
        const start = new Date(now)
        start.setHours(0, 0, 0, 0)

        const end = new Date(start)
        end.setDate(end.getDate() + 7)

        return eventDate >= start && eventDate < end
      }

      if (dateFilter.value === "month") {
        return (
          eventDate.getMonth() === now.getMonth() &&
          eventDate.getFullYear() === now.getFullYear()
        )
      }

      if (dateFilter.value === "nextMonth") {
        const nextMonth = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          1
        )

        return (
          eventDate.getMonth() === nextMonth.getMonth() &&
          eventDate.getFullYear() === nextMonth.getFullYear()
        )
      }

      return true
    })
  }

  result.sort((a, b) => {

    if (sortBy.value === "titleAsc") {
      return (a.title || "").localeCompare(
        b.title || "",
        "fr"
      )
    }

    if (sortBy.value === "titleDesc") {
      return (b.title || "").localeCompare(
        a.title || "",
        "fr"
      )
    }

    const dateA = getEventDate(a)
    const dateB = getEventDate(b)

    if (!dateA || !dateB) {
      return 0
    }

    if (sortBy.value === "dateDesc") {
      return dateB - dateA
    }

    return dateA - dateB
  })

  return result
})

const hasFilters = computed(() => {
  return (
    search.value ||
    locationFilter.value ||
    dateFilter.value ||
    sortBy.value !== "dateAsc"
  )
})

const getEventDate = event => {

  if (!event.date) {
    return null
  }

  const date = new Date(event.date)

  if (Number.isNaN(date.getTime())) {
    return null
  }

  return date
}

const formatDay = date => {

  if (!date) {
    return ""
  }

  const value = new Date(date)

  return value.toLocaleDateString("fr-FR", {
    day: "2-digit"
  })
}

const formatMonth = date => {

  if (!date) {
    return ""
  }

  const value = new Date(date)

  return value
    .toLocaleDateString("fr-FR", {
      month: "short"
    })
    .replace(".", "")
    .toUpperCase()
}

const formatTime = time => {

  if (!time) {
    return ""
  }

  return time.substring(0, 5)
}

const openEventDetails = publicId => {
  if (!publicId) {
    console.error("PublicId de l'événement manquant")
    return
  }

  router.push(`/events/${publicId}`)
}

const resetFilters = () => {
  search.value = ""
  locationFilter.value = ""
  dateFilter.value = ""
  sortBy.value = "dateAsc"
}

onMounted(() => {
  loadEvents()
})
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Instrument+Sans:wght@400;500;600;700&family=Noto+Serif+Armenian:wght@400;700&display=swap");
</style>

<style scoped>
.events-page {
  --red: #d90012;
  --red-deep: #8f0010;
  --blue: #0033a0;
  --orange: #f2a800;
  --ink: #1c1511;
  --ink-soft: #3a2f28;
  --muted: #6e6259;
  --paper: #faf6ef;
  --paper-2: #f3ecdf;
  --line: rgba(28, 21, 17, 0.12);
  --serif: "Fraunces", "Noto Serif Armenian", Georgia, serif;
  --sans: "Instrument Sans", "Inter", system-ui, sans-serif;
  --arm: "Noto Serif Armenian", "Fraunces", serif;

  position: relative;
  min-height: 100vh;
  padding: 130px clamp(16px, 5vw, 72px) 110px;
  overflow: hidden;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
}
.events-page *,
.events-page *::before,
.events-page *::after {
  box-sizing: border-box;
}

/* ---------- fond ---------- */
.bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.lattice {
  position: absolute;
  inset: 0 0 auto 0;
  height: 620px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='104' height='163' viewBox='-60 -50 505 792' fill='none' opacity='.24'%3E%3Cmask id='m' maskUnits='userSpaceOnUse' x='-20' y='-20' width='425' height='710'%3E%3Crect x='-20' y='-20' width='425' height='710' fill='%23fff'/%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23000' stroke-width='6' stroke-linejoin='round'/%3E%3C/mask%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23d90012' stroke-width='19' stroke-linejoin='round' mask='url(%23m)'/%3E%3Cg transform='translate(98 40) rotate(-45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(287 40) rotate(45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 166) rotate(70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 344) rotate(110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(291 645) rotate(135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(97 645) rotate(-135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 344) rotate(-110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 166) rotate(-70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Ccircle cx='140' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='112' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='112' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='272' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='272' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='140' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='110' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='110' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='275' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='275' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='192' cy='245' r='76' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Cline x1='254.0' y1='245.0' x2='266.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='266.2' x2='261.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='284.9' x2='248.7' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='298.7' x2='229.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='306.1' x2='204.8' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='306.1' x2='179.2' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='298.7' x2='155.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='284.9' x2='135.3' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='266.2' x2='122.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='130.0' y1='245.0' x2='118.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='223.8' x2='122.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='205.1' x2='135.3' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='191.3' x2='155.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='183.9' x2='179.2' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='183.9' x2='204.8' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='191.3' x2='229.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='205.1' x2='248.7' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='223.8' x2='261.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='245' r='54' fill='none' stroke='%23d90012' stroke-width='9'/%3E%3Cpath d='M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='192' cy='245' r='9' fill='%23d90012'/%3E%3Cpath d='M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Cpath d='M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='330.0' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='356.7' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='383.4' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='410.1' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='436.8' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='463.5' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='490.2' r='5' fill='%23d90012'/%3E%3Cg transform='translate(192 170) rotate(0)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(192 555) rotate(180)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cpath d='M192 560 L165 590 L192 600 L219 590Z' fill='none' stroke='%23d90012' stroke-width='6' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 104px 163px;
  -webkit-mask-image: radial-gradient(ellipse 70% 80% at 50% 0%, #000 0%, transparent 75%);
  mask-image: radial-gradient(ellipse 70% 80% at 50% 0%, #000 0%, transparent 75%);
}
.bg-cross {
  position: absolute;
  top: 56px;
  right: clamp(170px, 19vw, 320px);
  width: clamp(120px, 14vw, 220px);
  aspect-ratio: 453 / 752;
  height: auto;
  color: rgba(217, 0, 18, 0.1);
  user-select: none;
}

main {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}

/* ---------- en-tête ---------- */
.page-intro {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 40px;
  animation: rise 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--red);
  font: 700 13px/1 var(--sans);
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.kicker-cross {
  width: 19px;
  height: 32px;
  flex-shrink: 0;
}
.kicker::before {
  width: 28px;
  height: 2px;
  background: var(--red);
  content: "";
}
.page-intro h1 {
  margin: 16px 0 0;
  font: 600 clamp(36px, 5.4vw, 66px) / 1.06 var(--serif);
  letter-spacing: -0.03em;
}
.page-intro h1 em {
  color: var(--red);
  font-weight: 500;
}
.page-intro p {
  max-width: 520px;
  margin: 18px 0 0;
  color: var(--ink-soft);
  font-size: clamp(16px, 1.5vw, 18px);
  line-height: 1.7;
}

.create-event-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 0 26px;
  border: 0;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font: 600 15px/1 var(--sans);
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(217, 0, 18, 0.28);
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
}
.create-event-btn:hover {
  background: var(--red-deep);
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(217, 0, 18, 0.34);
}
.create-event-btn:focus-visible,
.reset-btn:focus-visible,
.reset-empty-btn:focus-visible,
.event-card:focus-visible {
  outline: 3px solid var(--orange);
  outline-offset: 3px;
}

/* ---------- filtres ---------- */
.filters {
  position: relative;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 24px 22px 22px;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 20px 50px rgba(28, 21, 17, 0.07);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  animation: rise 0.8s 0.1s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.filters::before {
  position: absolute;
  inset: 0 28px auto;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);
  content: "";
}
.search-box,
.filter-box {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}
.search-box label,
.filter-box label {
  color: var(--muted);
  font: 700 11px/1 var(--sans);
  letter-spacing: 0.14em;
  text-transform: uppercase;
}
.input-icon {
  position: relative;
}
.input-icon svg {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: var(--muted);
  pointer-events: none;
  transition: color 0.2s ease;
}
.input-icon:focus-within svg {
  color: var(--red);
}
.search-box input,
.filter-box select {
  width: 100%;
  height: 52px;
  border: 1.5px solid transparent;
  border-radius: 16px;
  background: var(--paper);
  color: var(--ink);
  font: 500 15px var(--sans);
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.search-box input {
  padding: 0 16px 0 46px;
}
.search-box input::placeholder {
  color: var(--muted);
  opacity: 0.8;
}
.filter-box select {
  padding: 0 40px 0 16px;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236e6259' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  text-overflow: ellipsis;
}
.search-box input:hover,
.filter-box select:hover {
  border-color: var(--line);
}
.search-box input:focus,
.filter-box select:focus {
  border-color: var(--red);
  background-color: #fff;
  box-shadow: 0 0 0 4px rgba(217, 0, 18, 0.08);
}

/* ---------- compteur ---------- */
.results-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 30px 4px 22px;
}
.count {
  color: var(--muted);
  font-size: 15px;
  font-weight: 500;
}
.count strong {
  margin-right: 4px;
  color: var(--ink);
  font: 600 24px var(--serif);
  letter-spacing: -0.02em;
}
.reset-btn {
  padding: 8px 14px;
  border: 0;
  border-radius: 999px;
  background: rgba(217, 0, 18, 0.08);
  color: var(--red-deep);
  font: 700 13px var(--sans);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.reset-btn:hover {
  background: var(--red);
  color: #fff;
}

/* ---------- grille ---------- */
.events-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 26px;
}

.event-card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(28, 21, 17, 0.06);
  cursor: pointer;
  transition: transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.4s ease, border-color 0.3s ease;
  animation: rise 0.7s calc(var(--i, 0) * 0.07s) cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.event-card::after {
  position: absolute;
  inset: auto 0 0 0;
  height: 4px;
  background: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  content: "";
}
.event-card:hover {
  transform: translateY(-8px);
  border-color: transparent;
  box-shadow: 0 30px 60px rgba(28, 21, 17, 0.14);
}
.event-card:hover::after {
  transform: scaleX(1);
}

.event-image {
  position: relative;
  height: 230px;
  overflow: hidden;
  background: var(--paper-2);
}
.event-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.event-card:hover .event-image img {
  transform: scale(1.07);
}
.event-image-placeholder {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
  background: repeating-linear-gradient(45deg, rgba(217, 0, 18, 0.06) 0 2px, transparent 2px 18px), var(--paper-2);
}
.placeholder-cross {
  height: 74%;
  aspect-ratio: 453 / 752;
  color: var(--red);
  opacity: 0.45;
}

.event-date {
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  width: 60px;
  height: 66px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
}
.event-date strong {
  color: var(--red);
  font: 700 24px/1 var(--serif);
}
.event-date span {
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.event-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px 26px 22px;
}
.event-location,
.event-time {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
}
.event-location {
  max-width: 100%;
  overflow: hidden;
  color: var(--red);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.event-location svg,
.event-time svg {
  flex-shrink: 0;
}
.event-content h2 {
  margin: 10px 0 0;
  font: 600 23px/1.25 var(--serif);
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}
.event-description {
  display: -webkit-box;
  margin: 12px 0 0;
  overflow: hidden;
  color: var(--muted);
  font-size: 15px;
  line-height: 1.65;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.event-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: auto;
  padding-top: 22px;
}
.event-footer::before {
  display: none;
}
.event-time {
  color: var(--muted);
}
.event-details-btn {
  color: var(--ink);
  font: 700 14px var(--sans);
  white-space: nowrap;
  transition: color 0.2s ease;
}
.event-details-btn .arrow {
  display: inline-block;
  transition: transform 0.25s ease;
}
.event-card:hover .event-details-btn {
  color: var(--red);
}
.event-card:hover .event-details-btn .arrow {
  transform: translateX(5px);
}

/* ---------- vide ---------- */
.events-empty {
  display: flex;
  max-width: 560px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 20px auto 0;
  padding: 50px 30px;
  border: 1.5px dashed rgba(28, 21, 17, 0.25);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.6);
  text-align: center;
  animation: rise 0.7s both;
}
.empty-cross {
  width: 52px;
  height: 86px;
  color: var(--red);
}
.events-empty h2 {
  margin: 4px 0 0;
  font: 600 26px var(--serif);
  letter-spacing: -0.02em;
}
.events-empty p {
  margin: 0 0 14px;
  color: var(--muted);
}
.reset-empty-btn {
  min-height: 44px;
  padding: 0 22px;
  border: 0;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font: 700 14px var(--sans);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.reset-empty-btn:hover {
  background: var(--red-deep);
  transform: translateY(-2px);
}

/* ---------- chargement ---------- */
.event-card.skeleton {
  min-height: 400px;
  animation: none;
  cursor: default;
}
.event-card.skeleton:hover {
  transform: none;
  box-shadow: 0 10px 30px rgba(28, 21, 17, 0.06);
}
.event-card.skeleton::after {
  display: none;
}
.sk {
  background: linear-gradient(100deg, #f1ebe0 30%, #faf6ef 50%, #f1ebe0 70%);
  background-size: 200% 100%;
  animation: shimmer 1.4s linear infinite;
}
.sk-img {
  height: 230px;
}
.sk-line {
  height: 18px;
  margin: 26px 26px 0;
  border-radius: 9px;
}
.sk-line.short {
  width: 50%;
  margin-top: 14px;
}
@keyframes shimmer {
  to { background-position: -200% 0; }
}

@keyframes rise {
  from { opacity: 0; transform: translateY(26px); }
}

/* ---------- responsive ---------- */
@media (max-width: 1024px) {
  .filters {
    grid-template-columns: 1fr 1fr;
  }
  .search-box {
    grid-column: 1 / -1;
  }
  .events-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 650px) {
  .events-page {
    padding-top: 108px;
    padding-bottom: 80px;
  }
  .bg-cross {
    top: 76px;
    right: -34px;
    width: 150px;
    opacity: 0.7;
  }
  .lattice {
    height: 480px;
    background-size: 80px 125px;
  }
  .page-intro {
    margin-bottom: 30px;
  }
  .create-event-btn {
    width: 100%;
    justify-content: center;
  }
  .filters {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 22px 16px 18px;
    border-radius: 22px;
  }
  .events-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .event-card:hover {
    transform: none;
  }
  .event-image {
    height: 210px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>